var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth" },
    [
      _c("div", { staticClass: "header" }, [
        _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.role.roleName))]),
        _c("p", { staticClass: "desc" }, [_vm._v(_vm._s(_vm.role.roleDesc))]),
      ]),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.dataType,
            callback: function ($$v) {
              _vm.dataType = $$v
            },
            expression: "dataType",
          },
        },
        _vm._l(_vm.tabs, function (item) {
          return _c("el-tab-pane", {
            key: item.value,
            attrs: {
              label: _vm.$t("stores::sync-log::" + item.label),
              name: item.value,
            },
          })
        }),
        1
      ),
      _c(_vm.dataType, {
        ref: _vm.dataType,
        tag: "component",
        attrs: { roleId: _vm.role.roleId },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }